import { Loader } from '@kanda-libs/ks-design-library';
import SubscriptionCard, {
  type SubscriptionCardProps,
} from './SubscriptionCard';
import useSubscriptionsBypass from './useSubscriptionsBypass';

const Subsctiptions: React.FunctionComponent = function () {
  const { subscriptions, isSubmitting, isLoading } = useSubscriptionsBypass();
  return (
    <div className="flex flex-col gap-y-6 mt-8 md:mt-16">
      <div className="flex flex-col md:flex-row gap-x-8 gap-y-4">
        {subscriptions.map((card: SubscriptionCardProps) => (
          <SubscriptionCard
            key={card.buttonProps.id}
            {...card}
            isLoading={isLoading}
          />
        ))}
        <Loader isLoading={isSubmitting} />
      </div>
    </div>
  );
};

export default Subsctiptions;
